module.exports = __webpack_public_path__ + "static/media/UserRounded.70b43776.svg";